import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
  loaderOptions: {
    autoHideBadge: true,
  },
})
